// extracted by mini-css-extract-plugin
module.exports = {"planDetailsContainer":"PlanDetails_planDetailsContainer__zk7hw","scrollTable":"PlanDetails_scrollTable__DBV8X","box":"PlanDetails_box__V8OOp"};